var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
let AccountManagementMainHeader = class AccountManagementMainHeader extends Vue {
    closeModal() {
        this.$emit('closeModal');
    }
    closeRightDrawer() {
        this.$emit('closeRightDrawer');
    }
};
__decorate([
    Prop({ default: 'Gerenciar Crédito' })
], AccountManagementMainHeader.prototype, "title", void 0);
__decorate([
    Prop({ default: false })
], AccountManagementMainHeader.prototype, "showingRightDrawer", void 0);
AccountManagementMainHeader = __decorate([
    Component({
        components: {
            Input,
        },
    })
], AccountManagementMainHeader);
export default AccountManagementMainHeader;
